<template lang="html">
  <div class="">
    <v-window
      :value="window"
      touchless
      color="transparent"
    >
      <v-window-item key="0">
        <si-container>
          <v-flex xs12>
            <v-card>
              <v-card-title>
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-select
                      v-model="view"
                      :items="viewOptions"
                      label="View"
                      outlined
                      single-line
                      hide-details
                      prepend-inner-icon="filter_list"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                  >
                    <v-select
                      v-model="sortKey"
                      :items="sortOptions"
                      label="Sorty by"
                      outlined
                      single-line
                      hide-details
                      prepend-inner-icon="sort"
                      :append-outer-icon="sortAscending ? 'arrow_downward': 'arrow_upward'"
                      @click:append-outer="sortAscending = !sortAscending"
                    />
                  </v-flex>
                </v-layout>
              </v-card-title>

              <v-list two-line>
                <div
                  v-for="(contact, i) in viewContacts"
                  :key="contact.id"
                >
                  <v-list-item
                    :to="`/contact/${contact.id}`"
                    :style="unSeenMarker(contact.timestamp)"
                  >
                    <v-list-item-avatar
                      :color="contact.color"
                      class="white--text ml-n1"
                    >
                      {{ _initials(contact.name) }}
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ contact.name }}<span class="ml-2">[{{ contact.email }}]</span></v-list-item-title>
                      <v-list-item-subtitle class="">
                        {{ contact.subject }}
                      </v-list-item-subtitle>
                    <!-- <v-list-item-subtitle class="caption">
                    </v-list-item-subtitle> -->
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-list-item-action-text>{{ _timeAgo(contact.timestamp) }}</v-list-item-action-text>
                      <div v-if="(contact.responded || {}).state">
                        <span class="caption">{{ _formatDateTime((contact.responded || {}).timestamp) }}</span>
                        <SiUserAvatar
                          size="24"
                          :uid="(contact.responded || {}).uid"
                          class="mx-2"
                        />
                      </div>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="i < (viewContacts || []).length -1"
                    inset
                  />
                </div>
                <template v-if="(viewContacts || []).length === 0 && !_loader ">
                  <v-list-item>
                    <v-list-item-title class="grey--text font-italic">
                      No contact contacts to show...
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-card>
          </v-flex>
        </si-container>
      </v-window-item>
      <v-window-item key="1">
        <si-container back="/contact">
          <v-flex xs12>
            <v-card>
              <v-card-title class="grey lighten-2 pa-0">
                <v-flex pa-4>
                  <SiAssignee
                    outlined
                    hide-details
                    :value="activeContact.assignee"
                    :disabled="!!activeContact.responded"
                    @change="setAssignee(activeContact.id, $event)"
                  />
                </v-flex>
                <v-spacer />
                <v-flex
                  pa-4
                  shrink
                >
                  <v-checkbox
                    :value="activeContact.responded"
                    hide-details
                    class="ma-0 pa-0"
                    label="Responded"
                    @change="setResponded(activeContact.id, $event)"
                  />
                  <div v-if="(activeContact.responded || {}).state">
                    <SiUserAvatar
                      size="24"
                      :uid="(activeContact.responded || {}).uid"
                      class="mr-2"
                    />
                    <span class="caption">{{ _formatDateTime((activeContact.responded || {}).timestamp) }}</span>
                  </div>
                </v-flex>
              </v-card-title>
              <v-card-title class="body-1 py-4">
                <v-avatar
                  :color="activeContact.color"
                  class="white--text mr-2"
                >
                  {{ activeContact.initials }}
                </v-avatar>
                <span class="my-3">{{ activeContact.name }} [{{ activeContact.email }}]</span>
                <v-spacer />
              </v-card-title>
              <v-divider />
              <v-card-text class="title">
                {{ activeContact.subject }}
              </v-card-text>
              <v-card-text v-html="_formatLineBreaks(activeContact.message)" />
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="primary"
                  text
                  :href="`mailto:${activeContact.email}?subject=[Contact Request] RE: ${activeContact.subject}`"
                >
                  <v-icon left>
                    send
                  </v-icon>Compose Reply
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </si-container>
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { forEach, sortBy, maxBy } from 'lodash'
import { rtdb } from '@/plugins/firebase'
import moment from 'moment'
import helpers from '@/mixins/helpers'
import durations from '@/mixins/durations'
import binder from '@/mixins/binder'
import seen from '@/mixins/seen'
import colors from 'vuetify/lib/util/colors'

export default {
  mixins: [ helpers, durations, binder, seen ],
  data () {
    return {
      seenLast: null,
      clientColors: {},
      contacts: [],
      contactsObj: {},
      sortKey: 'timestamp',
      sortAscending: false,
      view: 'open',
      viewOptions: [
        { text: 'Open', value: 'open' },
        { text: 'Closed', value: 'closed' }
      ],
      sortOptions: [
        { text: 'Date', value: 'timestamp' },
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Subject', value: 'subject' },
      ]
    }
  },
  computed: {
    ...mapGetters(['_loader', '_badgeTotals', '_user']),
    window () {
      return this.$route.params.sub ? 1 : 0
    },
    activeContact () {
      return this.contactsObj[this.$route.params.sub] || {}
    },
    openContacts () {
      return this.contacts.filter( c => !c.responded)
    },
    closedContacts () {
      return this.contacts.filter( c => c.responded)
    },
    viewContacts () {
      return this.view === 'open' ? this.openContacts : this.closedContacts
    }
  },
  watch: {
    sortAscending () {
      this.sortResults()
    },
    sortKey () {
      this.sortResults()
    },
    contacts (v, ov) {
      if ((ov || []).length === 0 && (v || []).length > 0) {
        let timestamp = maxBy(v, 'timestamp').timestamp
        this._seenUpdate('contact', timestamp)
      }
    },
    _badgeTotals () {
      if (!this.$route.params.sub) this._seenUpdate('contact')
    }
  },
  beforeMount () {
    this.seenLast = this._seenLast('contact')
    this._seenWatch('contact', !this.$route.params.sub)
    this.bindContacts()
    this.$store.commit('set_appBarTitle', {title: 'Contact', icon: 'email'})
  },
  mounted () {
    this._seenUpdate('contact')
  },
  methods: {
    bindContacts () {
      const callback = (v)  => {
        this.buildList(v)
        this.sortResults()
      }
      this.$bindRtdb(
        'contacts', 
        rtdb.ref(`webForms/contact`).orderByChild('timestamp'), 
        { callback, loader: true }
      )
    },
    buildList (contacts) {
      this.contactsObj = {}
      this.contacts = []

      forEach(contacts, (c, id) => {
        let clientHash = window.btoa(c.email)
        if (!this.clientColors[clientHash]) this.clientColors[clientHash] = this._randomMaterialColor()

        c.color = this.clientColors[clientHash]
        c.name = `${c.firstName} ${c.lastName}`
        c.id = id
        c.initials = this._initials(`${c.firstName} ${c.lastName}`)
        // arr.push(c)
        this.contactsObj[id] = c
        this.contacts.unshift(c)
      })
      // this.contacts = arr.reverse()
    },
    sortResults () {
      if (this.sortAscending) {
        this.contacts = sortBy(this.contacts, [this.sortKey, 'name'])
      } else {
        this.contacts = sortBy(this.contacts, [this.sortKey, 'name']).reverse()
      }
    },
    unSeenMarker (ts) {
      let color = colors.blue.base
      if (moment(ts).isSameOrBefore(this.seenLast, 'second')) color = 'transparent'
      return `border-left: 4px ${color} solid;`
    },
    setAssignee (id, uid) {
      rtdb.ref(`webForms/contact/${id}/assignee`).set(uid)
    },
    setResponded (id, state) {
      var response = {
        state: state,
        uid: this._user.uid,
        timestamp: new Date().toISOString()
      }
      if (!this.contactsObj[id].assignee) this.setAssignee(id, this._user.uid)
      rtdb.ref(`webForms/contact/${id}/responded`).set(state ? response : null)
    }
  }
}
</script>
2/12/120
<style lang="css" scoped>

</style>
